import CaptchaReturnModal from './CaptchaReturnModal';
export default CaptchaReturnModal;
